import { observable, computed, action, decorate } from "mobx";
import * as mobx from 'mobx';
import { runInAction } from "mobx";

import * as ebooks from '../communicator/ebooks';
import { afterStartup } from '../utilities/defer';

class StoreEBooks {
    eBooksList = []

    constructor() {
        // Alleen de e-boekenpagina gebruikt dit (en laadt het daar zelf als het ontbreekt).
        afterStartup(() => this.getEBooks('all'));
    }

    async getEBooks() {
        try {
            const books = await ebooks.getEBooks();
            runInAction(() => {
                this.eBooksList = books.data;
            })
        } catch (error) {
            runInAction(() => {
                this.state = "error"
            })
        }
    }

    async getEBookDetails(sku) {
        let stock;
        try {
            const books = await ebooks.getEBookDetails(sku);
            runInAction(() => {
                stock = books.data[0];
                return stock;
            })
        } catch (error) {
            runInAction(() => {
                this.state = "error"
            })
        }
        return stock;
    }
}

decorate(StoreEBooks, {
    eBooksList: observable,
    getEBooks: action,
    getEBookDetails: action
})

export default StoreEBooks;